module.exports = __webpack_public_path__ + "img/Weapon_42.0d9fa41c.png";